import React from 'react';
import FormPlan from '../components/FormMakeYourPlanNew/FormPlan';
import '../assets/css/form_make_your_plan_new.css';
import urlBase from '../url-base';


const FormMakeYourPlanNew = (e) => {

  let showPage = true;
  let listPlan = ['plan1', 'plan2', 'plan3', 'plan4', 'plan5', 'plan6'];
  let planConfigList = {
    'plan1' : {dental_plan: '5d76652517185e4be41e6ea3', payment_plan: "true", type_plan: 'digital'},
    'plan2' : {dental_plan: '5b512e56a44a486a9aaf68f8', payment_plan: "true", type_plan: 'vip'},
    'plan3' : {dental_plan: '5b512e56a44a486a9aaf68f9', payment_plan: "true", type_plan: 'orto'},
    'plan4' : {dental_plan: '5b512e56a44a486a9aaf68f6', payment_plan: "true", type_plan: 'super'},
    'plan5' : {dental_plan: '5b512e56a44a486a9aaf68f7', payment_plan: "false", type_plan: 'super'},
    'plan6' : {dental_plan: '5b512e56a44a486a9aaf68fa', payment_plan: "false", type_plan: 'orto'},
    'plan7' : {dental_plan: '627a98a6c700f01961d6f79c', payment_plan: "true", type_plan: 'orto'},

  };


  if (e.location.query.codpl) {

    if (e.location.query.codpl.length > 0 && listPlan.indexOf(e.location.query.codpl) > -1) {
      localStorage.setItem("dental_plan", planConfigList[e.location.query.codpl].dental_plan);
      localStorage.setItem("payment_plan", planConfigList[e.location.query.codpl].payment_plan);
      localStorage.setItem("type_plan", planConfigList[e.location.query.codpl].type_plan);
    }
    else {
      showPage = false;
    }
  }
  return (
    <div>
      {
        showPage == true ? (
      <FormPlan />
        ) : (
      <div style={{color: '#606060', fontFamily: 'RubikBold', width: '90%', margin: '0 auto', marginTop: 100}}>
        <h3>Plano informado incorreto</h3>

        <h5 style={{marginTop: 30}}>Escolha um dos planos:</h5>

        <ul style={{padding: 0}}>
          <li style={{listStyleType: 'none'}}>
            <a href={urlBase.client + 'formmakeyourplan?codpl=plan1'}>DENTAL DIGITAL</a>
          </li>

          <li style={{listStyleType: 'none'}}>
            <a href={urlBase.client + 'formmakeyourplan?codpl=plan2'}>DENTAL VIP CLÍNICO</a>
          </li>

          <li style={{listStyleType: 'none'}}>
            <a href={urlBase.client + 'formmakeyourplan?codpl=plan3'}>DENTAL VIP ORTO E CLINICO</a>
          </li>

          <li style={{listStyleType: 'none'}}>
            <a href={urlBase.client + 'formmakeyourplan?codpl=plan4'}>DENTAL CLÍNICO - CARTÃO</a>
          </li>

          <li style={{listStyleType: 'none'}}>
            <a href={urlBase.client + 'formmakeyourplan?codpl=plan5'}>DENTAL CLÍNICO - BOLETO</a>
          </li>

          <li style={{listStyleType: 'none'}}>
            <a href={urlBase.client + 'formmakeyourplan?codpl=plan6'}>DENTAL ORTO - BOLETO</a>
          </li>
        </ul>
      </div>
        )
      }
    </div>
  );
};

export default FormMakeYourPlanNew;



/** WEBPACK FOOTER **
 ** ./src/containers/FormMakeYourPlanNew.js
 **/